import { API } from "../urls";

const fetchOpts = { credentials: "include" };

/**
 * Banka/sağlayıcıya bildirilecek sunucu çıkış IP'si.
 * Backend'de tanımlı değilse data.ip null gelir; çağıran kart çizmez.
 */
export const fetchServerIp = async () => {
    const res = await fetch(API.integration_server_ip, fetchOpts);
    return res.json();
};
